// IMPORTS
// OHS
import { OHSListDataFormatter } from '../../../../../onehivesystems/js/OHSList';
import { OHSFormItem, OHSFormSubmit, OHSFormSubmitListener, OHSFormDataExtractor, OHSFormDataClearer, OHSFormSelectBuilder } from '../../../../../onehivesystems/js/OHSForm';
import OHSCRUD from '../../../../../onehivesystems/js/OHSCRUD';
// Assets
import { commandModel } from './../_variables';
import InsertableFields from './InsertableFields';


// COMPONENT
export default function Command (props) {
   // Functions
   const updateCommand = function () {
      OHSCRUD({
         url: '/v1/oneport/commands/' + props.content.id.value,
         method: 'PUT',
         payload: OHSFormDataExtractor('oneport-command'),
         success: function (data) {
            var temp = props.parent.commands;
            temp[props.index] = OHSListDataFormatter(data[0], commandModel);
            props.parent.setCommands(temp)
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true
      });
   }
   const deleteCommand = function () {
      OHSCRUD({
         url: '/v1/oneport/commands/' + props.content.id.value,
         method: 'DELETE',
         success: function () {
            props.hidePopup(props.index);
            var temp = props.parent.commands;
            temp.splice(props.index, 1);
            props.parent.setCommands(temp);
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         setOHSConfirmation: props.onehive.setConfirmation,
         confirmMessage: "Are you sure you wish to delete this command?",
         showSuccessPopup: true
      });
   }

   // Component
   return (
      <div id='oneport-command' className='oneport-command' onKeyDown={(e) => {OHSFormSubmitListener(e, updateCommand);}}>
         <OHSFormItem onehive={props.onehive} title="Name">
            <input type='text' className='ohsinput' defaultValue={props.content.name.value} data-ohsformdata='name' />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Collection">
            <OHSFormSelectBuilder onehive={props.onehive} content={props.parent.collections} selected={props.content.collection_id.value} field={'name'} blank={false} ohsformdata='collection_id' />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Commands">
            <textarea className='ohsinput-terminal oneport-command-terminal' defaultValue={props.content.commands.value} data-ohsformdata='commands'></textarea>
         </OHSFormItem>
         <OHSFormSubmit onehive={props.onehive} update={updateCommand} clear={() => {OHSFormDataClearer('oneport-command');}} delete={deleteCommand} keyListener={true} />
         <InsertableFields onehive={props.onehive} parent={{
            fields: props.parent.fields
         }} />
      </div>
   );
}